import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const zkcandyConfig: StaticEthereumBlockchainConfig = {
  name: "ZKcandy",
  icon: "/images/blockchains/zkcandy.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://zkcandy-api.rarible.org",
  chainId: 320,
  chainName: "ZKcandy",
  blockchain: Blockchain.ZKCANDY,
  viem: {
    id: 320,
    name: "ZKcandy",
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: {
      default: { http: ["https://rpc.zkcandy.io"] },
    },
    blockExplorers: {
      default: {
        name: "ZKcandy Explorer",
        url: "https://explorer.zkcandy.io",
      },
    },
  },
  blockExplorers: [
    {
      url: "https://explorer.zkcandy.io",
      icon: "/images/scanner.svg",
      adress: "https://explorer.zkcandy.io/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "zkcandy-node",
  transferProxies: {
    nft: "0x02D4207A4dD1C940C4596af255c051B94288CfD5",
    erc20: "0xb6379392FFA328252c188D4a846573C5222CFB96",
    erc721Lazy: "0x5d01eF93fA988c26fAfef05118Dc3384C9D25242",
  },
  exchange: {
    v2: "0x9242eD19f0978302E2CD0B973e0c4B49042aDfCE",
    wrapper: "0x20FB4cBec4228a342a46536f32Ac1973D3DeABb4",
  },
  addFundsLink: "https://bridge.zkcandy.io/bridge",
  primaryCurrency: {
    id: toCurrencyId("ZKCANDY:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ethereum",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("ZKCANDY:0x1e347256309b4764edd8d7bdf4aa4ecb62b58320"),
    symbol: "WETH",
    name: "Wrapped Ethereum",
    decimals: 18,
  },
  feeConfigUrl: FEE_CONFIG_URL,
  hasStabilityProtocol: true,
}

export const getZKcandyConfig = (): StaticEthereumBlockchainConfig =>
  zkcandyConfig
